import { render } from "./BookingForm.vue?vue&type=template&id=e1831776"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__